module.exports = __webpack_public_path__ + "CraftworkGrotesk-Bold.114a8f04f1e5b6cb0bd0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/grotesc/CraftworkGrotesk-Bold.woff
// module id = ./src/assets/webfonts/grotesc/CraftworkGrotesk-Bold.woff
// module chunks = styles